// src/features/quests/questSocket.js

const QUEST_EVENT = "quest_message";

// Example: user clicks a web UI button that should notify Unity quest system:
// emitQuestAction(socket, {
//   questId: quest.questState.questId,
//   userId,
//   roomId: loadedRoomId || localStorage.getItem("lastRoomId"),
//   actionType: "TREASURE_HUNT_OPENED_MAP",
//   payload: { source: "web-ui" },
// });

// Unity emits
// {
//   "v":1,
//   "type":"QUEST_ACTION",
//   "questId":"...",
//   "roomId":"...",
//   "actorUserId":"...",
//   "action":{"actionType":"TREASURE_HUNT_COMPLETE","payload":{}},
//   "ts":...
// }

// when a button is clicked or action on web is done you can do this to notify Unity
// quest.sendQuestAction({
//   actionType: "TREASURE_HUNT_COMPLETE",
//   payload: { chestId: "chest_03", reward: "gold" },
//   roomId: loadedRoomId, // optional
// })

// or

// const handleArcadeWin = () => {
//   quest.sendQuestAction({
//     actionType: "ARCADE_WIN",
//     payload: { score: 1200 },
//     roomId: loadedRoomId,
//   });
// };

export function joinQuestChannel(socket, { questId, userId, otherUserIds = [] }) {
    if (!socket || !questId || !userId) return;

    socket.emit(QUEST_EVENT, {
        v: 1,
        type: "QUEST_JOIN",
        questId,
        actorUserId: userId,
        targets: { userIds: [userId, ...otherUserIds].filter(Boolean) },
        ts: Date.now(),
    });
}

export function leaveQuestChannel(socket, { questId, userId }) {
    if (!socket || !questId || !userId) return;

    socket.emit(QUEST_EVENT, {
        v: 1,
        type: "QUEST_LEAVE",
        questId,
        actorUserId: userId,
        ts: Date.now(),
    });
}

export function emitQuestAction(socket, { questId, userId, roomId, actionType, payload }) {
    if (!socket || !questId || !userId || !actionType) return;

    socket.emit(QUEST_EVENT, {
        v: 1,
        type: "QUEST_ACTION",
        questId,
        roomId: roomId || null,
        actorUserId: userId,
        action: { actionType, payload: payload || {} },
        ts: Date.now(),
    });
}
